export const getUserQueryKey = ['users'];
//# sourceMappingURL=query-key.js.map